"use strict";

var _defineProperty = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlags = exports.Flags = void 0;

var react_1 = __importDefault(require("react"));

var useReactifySearchContext_1 = require("./useReactifySearchContext");

var utility_1 = require("../utility");

var Flags;

(function (Flags) {
  Flags["SENSOR_SORT"] = "reactify-search:flag_sensor_sort";
  Flags["SENSOR_COLLECTION"] = "reactify-search:flag_sensor_collection";
  Flags["SENSOR_PUBLISHED"] = "reactify-search:flag_sensor_published";
  Flags["SENSOR_INVENTORYAVAILABLE"] = "reactify-search:flag_sensor_inventoryavailable";
  Flags["SENSOR_SEARCHTERM"] = "reactify-search:flag_sensor_searchterm";
  Flags["SENSOR_SEARCHTERM_VALUE"] = "reactify-search:flag_sensor_searchterm_value";
  Flags["SENSOR_SEARCHTERM_PHRASE"] = "reactify-search:flag_sensor_searchterm_phrase";
  Flags["SENSOR_SEARCHTERM_PHRASE_SYNONYMS"] = "reactify-search:flag_sensor_searchterm_phrase_synonyms";
  Flags["SENSOR_SEARCHTERM_PHRASE_PREFIX"] = "reactify-search:flag_sensor_searchterm_phrase_prefix";
  Flags["SENSOR_SEARCHTERM_PHRASE_PREFIX_SYNONYMS"] = "reactify-search:flag_sensor_searchterm_phrase_prefix_synonyms";
  Flags["SENSOR_SEARCHTERM_CROSS_FIELDS"] = "reactify-search:flag_sensor_searchterm_cross_fields";
  Flags["SENSOR_SEARCHTERM_CROSS_FIELDS_SYNONYMS"] = "reactify-search:flag_sensor_searchterm_cross_fields_synonyms";
  Flags["SENSOR_SEARCHTERM_SPAN_FIRST"] = "reactify-search:flag_sensor_searchterm_span_first";
  Flags["SENSOR_SEARCHTERM_SPAN_FIRST_SYNONYMS"] = "reactify-search:flag_sensor_searchterm_span_first_synonyms";
})(Flags = exports.Flags || (exports.Flags = {}));

var useFlags = function useFlags() {
  var _ref = (0, useReactifySearchContext_1.useReactifySearchContext)(),
      options = _ref.options;

  var _react_1$default$useS = react_1.default.useState(Date.now()),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      delta = _react_1$default$useS2[0],
      setDelta = _react_1$default$useS2[1];

  var getFlag = react_1.default.useCallback(function (flag) {
    var _a;

    if (typeof window === "undefined") {
      return true;
    }

    var flagFromOptions = (_a = options.flags) === null || _a === void 0 ? void 0 : _a[flag];
    var flagFromSession = window.sessionStorage.getItem(flag) === "false" ? false : true;

    if (typeof flagFromOptions === "undefined") {
      return flagFromSession;
    }

    return flagFromOptions;
  }, [delta]);
  var setFlag = react_1.default.useCallback(function (flag, value) {
    if (typeof window === "undefined") {
      return;
    }

    window.sessionStorage.setItem(flag, "".concat(value));
    setDelta(Date.now());
  }, [delta]);
  var flags = react_1.default.useMemo(function () {
    return Object.values(Flags).reduce(function (acc, flag) {
      return Object.assign(Object.assign({}, acc), _defineProperty({}, flag, getFlag(flag)));
    }, {});
  }, [delta]);
  react_1.default.useEffect(function () {
    for (var _i = 0, _Object$values = Object.values(Flags); _i < _Object$values.length; _i++) {
      var flag = _Object$values[_i];
      setFlag(flag, getFlag(flag));
    }
  }, []);
  react_1.default.useEffect(function () {
    utility_1.debug.log("useFlags", "flags", flags);
  }, [flags]);
  return {
    flags: flags,
    setFlag: setFlag,
    getFlag: getFlag
  };
};

exports.useFlags = useFlags;